class NotifyModal extends HTMLElement {
  constructor() {
    super();
    this.delay = this.dataset.delay ? parseInt(this.dataset.delay, 10) : 200;
    this.openBtn = this.querySelector('[data-modal-open]');
    this.closeBtn = this.querySelector('[data-notify-modal-close]');
    this.content = this.querySelector('[data-notify-modal-content]');
    this.contentID = this.querySelector('[data-notify-modal-content]').getAttribute("id");
    this.emailInput = this.querySelector('[data-modal-email]');
    this.notifyMsg = this.querySelector('[data-pre-success-msg]');
    this.invalidText = this.querySelector('[data-email-invalid]');
    this.innerContent = this.querySelector('[data-inner-content]');
    this.notifyButton = this.querySelector('[data-notify-button]');
    this.emailSection = this.querySelector('[data-email-form-section]');
    this.marketingCheckbox = this.querySelector('[data-marketing-checkbox]');
    this.variantId = this.openBtn.getAttribute('data-notify-variant-id');
    this.productId = this.openBtn.getAttribute('data-notify-product-id');
    this.variantTitle = this.openBtn.getAttribute('data-notify-title');

    // Success variables
    this.preMsgOne = this.querySelector('[data-success-msg-1]');
    this.preMsgTwo = this.querySelector('[data-success-msg-2]');
    this.bigClose = this.querySelector('[data-button-big-close]');
    this.checkCircle = this.querySelector('[data-success-circle]');
    this.successClose = this.querySelector('[data-button-big-close]');
  }

  connectedCallback() {
    setTimeout(() => {
      this.openBtn.addEventListener('click', () => {
      this.sliderArrows = document.querySelectorAll('.slider-arrow'); // instagram slider arrows
        this.moveModal(this.contentId);
        this.content.classList.replace('hidden', 'flex');
        setTimeout(() => {
          this.content.classList.remove('opacity-0');
        }, 10);

        this.toggleSliderArrows(false); // Hide instagram slider arrows when modal is opened

        window.addEventListener('click', (e) => {
          this.handleBodyClick(e);
          console.log('click on notify');
        });

        window.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            this.close();
          }
        });
      });

      this.closeBtn.addEventListener('click', () => {
        this.close();
      });

      this.bigClose.addEventListener('click', () => {
        this.close();
      });

      this.notifyButton.addEventListener('click', () => {
        const email = this.emailInput.value;
        const isValidEmail = /^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/.test(email);
        const marketingConsent = this.marketingCheckbox.checked ? true : false;

        // console.log('email', email);
        // console.log('marketingConsent', marketingConsent);

        if (isValidEmail) {
          // console.log('Email is valid.');
          // console.log('Email', this.emailInput.value);
          // console.log('Marketing', this.marketingCheckbox.checked);
          this.recordNotify(this.bigClose,
                            this.notifyButton,
                            this.notifyMsg,
                            this.emailSection,
                            this.preMsgOne,
                            this.preMsgTwo,
                            this.checkCircle,
                            this.delay,
                            email,
                            marketingConsent);

          Array.prototype.forEach.call(document.querySelectorAll("[data-modal-email]"), function(emailValue){
            emailValue.value = email
          });
        } else {
          console.log('Email is not valid.');
          this.invalidText.classList.remove('hidden');
        }
      });
    }, 20);
  }

  close() {
    this.content.classList.add('opacity-0');
    setTimeout(() => {
      this.content.classList.replace('flex', 'hidden');
      this.invalidText.classList.add('hidden');
      // this.querySelector('[data-modal-close-span]>span').classList.replace('bg-[#343a40]', 'bg-red');
    }, this.delay);

    this.toggleSliderArrows(true); // Show instagram slider arrows when modal is closed
    window.removeEventListener('click', (e) => {
      this.handleBodyClick(e);
    });
    window.removeEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.close();
      }
    });
  }

  moveModal() {
    const modalContainer = document.getElementById('modal-container');
    const modalContent = document.getElementById(this.contentID);

    modalContainer.appendChild(modalContent);
  }

  recordNotify(bigClose,
               notifyButton,
               notifyMsg,
               emailSection,
               preMsgOne,
               preMsgTwo,
               checkCircle,
               delay,
               email,
               checkbox) {
    $.ajax({
      type: "POST",
      url: "https://app.restockrocket.io/api/v1/intents.json",
      data: JSON.stringify({
        "intent": {
          "shopify_variant_id": this.variantId,
          "shopify_product_id": this.productId,
          "channel": "email",
          "quantity": 1,
          "source": "api"
        },
        "customer": {
          "email": email,
          "accepts_marketing": checkbox
        },
        "product": {
          "title": this.variantTitle,
          "variant_count": 1,
          "variant_title": this.variantTitle
        }
      }),
      headers: {
        "X-Shopify-Shop-Domain": "rammount.myshopify.com",
        "Content-Type": "application/json"
      },
      success: function(data) {
        // Handle success response
        // console.log(JSON.stringify(data["errors"]["intent"]));
        // "Intent already exists for these parameters"
        // let event = new Event('click');
        // button.dispatchEvent(event);
        // console.log(JSON.stringify(data));
        setTimeout(() => {
          // this.closeBtnSpan.classList.replace('bg-red', 'bg-[#343a40]');
          notifyButton.classList.add('hidden')
          notifyMsg.classList.add('hidden');
          emailSection.classList.add('hidden');
          preMsgOne.classList.remove('hidden');
          preMsgTwo.classList.remove('hidden');
          checkCircle.classList.remove('hidden');
          bigClose.classList.remove('hidden');
        }, delay);
      },
      error: function(jqXHR, textStatus, errorThrown) {
        // Handle error response
        console.log(jqXHR);
        console.log(textStatus);
        console.log(errorThrown);
      }
    });
  }

  handleBodyClick(e) {
    const { target } = e;
    if (target !== this.innerContent && !target.closest('[data-inner-content]') && !target.closest('[data-modal-open]')) {
      this.close();
    }
  }

  toggleSliderArrows(show) {
    if (this.sliderArrows.length > 0) {
      for (var i = 0; i < this.sliderArrows.length; i++) {
        this.sliderArrows[i].style.display = show ? 'block' : 'none';
      }
    }
  }
}

customElements.define('notify-modal', NotifyModal);
